import { useLang } from '../../../../../../../../hooks/use-lang';
import { useDishCategoryStore } from '../../../../../../../../store/use-dish-category-store';
import { useDishSectionStore } from '../../../../../../../../store/use-dish-section-store';
import { useDishStore } from '../../../../../../../../store/use-dish-store';
import { LangType, validateLang } from '../../../../../../../../helpers/lang';
import { validate } from '../../../../../../../../helpers/validate';
import { useMemo } from 'react';
import { IdValue } from '../../../../../../../../types/props';
import { DishSectionType } from '../../../../../../../../store/api/dish-section-api';
import { getCurrentMenu } from '../../../menu-informer-helpers';

export const useMenuInformerCreateDishModalStep2 = () => {
  const { t, getLocale } = useLang();

  const { dish, handleUpdateDish } = useDishStore();

  const menu = getCurrentMenu();

  const { postSection, putSection, isLoading: isLoadingSection } = useDishSectionStore();

  const { postCategory, putCategory, isLoading: isLoadingCategory, list } = useDishCategoryStore();

  const handleConfirmSection = async (id?: string, value: LangType = {}) => {
    const isValid = validate({
      section: { rule: () => validateLang(value) },
    });
    if (!isValid) return;

    const element = menu?.sections?.find((item) => item.id === Number(id));
    if (element) {
      await putSection({ ...element, name: value });
      handleUpdateDish({ section_id: Number(id) });
    } else {
      const created = await postSection({ name: value });
      handleUpdateDish({ section_id: created?.id });
    }
  };

  const handleConfirmCategory = async (id?: string, value?: LangType) => {
    const isValid = validate({
      category: { rule: () => validateLang(value) },
    });
    if (!isValid) return;

    const element = list?.find((item) => item.id === Number(id));

    if (element) {
      await putCategory({ ...element, name: value || {} });
      handleUpdateDish({ category_id: Number(id) });
    } else {
      const created = await postCategory({ name: value!, section_id: dish!.section_id! });
      handleUpdateDish({ category_id: created?.id });
    }
  };
  const {
    categoryIdValues,
    sectionIdValues,
    selectedCategory,
    selectedSection,
    categories,
    sections,
  } = useMemo(() => {
    const newSection: LangType = {
      en: 'New section',
      ru: 'Новый раздел',
      kz: 'Жаңа бөлім',
      ch: '新部分',
    };

    const sections: Partial<DishSectionType>[] = [
      { id: 0, name: newSection },
      ...(menu?.sections || []),
    ];

    const sectionIdValues: IdValue[] = sections.map((item) => ({
      id: String(item.id),
      value: getLocale(item.name),
    }));

    const selectedSection = sectionIdValues.find((item) => item.id === String(dish?.section_id));

    const newCategory: LangType = {
      en: 'New category',
      ru: 'Новая категория',
      kz: 'Жаңа категория',
      ch: '新类别',
    };

    const categories = [
      { id: 0, name: newCategory },
      ...(sections.find((item) => item.id === dish?.section_id)?.categories || []),
    ];

    const categoryIdValues: IdValue[] = categories.map((item) => ({
      id: String(item.id),
      value: getLocale(item.name),
    }));

    const selectedCategory = categoryIdValues.find((item) => item.id === String(dish?.category_id));

    return {
      categoryIdValues,
      sectionIdValues,
      selectedSection,
      selectedCategory,
      categories,
      sections,
    };
  }, [dish?.category_id, dish?.section_id, getLocale, menu?.sections]);

  const handleSelectSection = (data: IdValue) => {
    const found = sections?.find((section) => section.id === Number(data.id));
    if (found) handleUpdateDish({ section_id: found.id || undefined, category_id: undefined });
  };

  const handleSelectCategory = (data: IdValue) => {
    const found = categories?.find((category) => category.id === Number(data.id));
    if (found) handleUpdateDish({ category_id: found.id || undefined });
  };

  return {
    t,
    dish,
    handleConfirmSection,
    isLoadingSection,
    handleConfirmCategory,
    isLoadingCategory,
    selectedSection,
    selectedCategory,
    categoryIdValues,
    sectionIdValues,
    handleSelectSection,
    handleSelectCategory,
  };
};
